/*       */

import validate from 'validate.js';
import isValidUuid from 'uuid-validate';

// eslint-disable-next-line
const RFC_3986_URI_CUSTOMIZED = /^(?:[a-z][a-z0-9+-\.]*(:\/\/)?(?:(?:(?:[a-z0-9-\._~%0-9a-f!\$&'\(\)\*\+,;=:]*@)?(?:\[(?:(?:(?:[0-9a-f]{1,4}:){6}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:0?0?[0-9]|0?[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\.){3}(?:0?0?[0-9]|0?[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]))|::(?:[0-9a-f]{1,4}:){5}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:0?0?[0-9]|0?[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\.){3}(?:0?0?[0-9]|0?[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]))|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:0?0?[0-9]|0?[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\.){3}(?:0?0?[0-9]|0?[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]))|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:0?0?[0-9]|0?[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\.){3}(?:0?0?[0-9]|0?[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]))|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:0?0?[0-9]|0?[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\.){3}(?:0?0?[0-9]|0?[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]))|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:0?0?[0-9]|0?[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\.){3}(?:0?0?[0-9]|0?[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]))|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:0?0?[0-9]|0?[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\.){3}(?:0?0?[0-9]|0?[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|v[0-9a-f]+\.[a-z0-9-\._~!\$&'\(\)\*\+,;=:]+)\]|(?:(?:0?0?[0-9]|0?[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\.){3}(?:0?0?[0-9]|0?[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])|[a-z0-9-\._~%0-9a-f!\$&'\(\)\*\+,;=]{0,255})(?::[0-9]*)?(?:\/[a-z0-9-\._~%0-9a-f!\$&'\(\)\*\+,;=:@]*)*)|\/(?:[a-z0-9-\._~%0-9a-f!\$&'\(\)\*\+,;=:@]+(?:\/[a-z0-9-\._~%0-9a-f!\$&'\(\)\*\+,;=:@]*)*)?|[a-z0-9-\._~%0-9a-f!\$&'\(\)\*\+,;=:@]+(?:\/[a-z0-9-\._~%0-9a-f!\$&'\(\)\*\+,;=:@]*)*))(?:\?[a-z0-9-\._~%0-9a-f!\$&'\(\)\*\+,;=:@\/\?]*(?=#|$))?(?:#[a-z0-9-\._~%0-9a-f!\$&'\(\)\*\+,;=:@\/\?]*)?$/;

// const LINK = new RegExp('^(https?:\\/\\/)|(\\/)' + // protocol
//   '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
//   '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
//   '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
//   '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
//   '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

const DATETIME = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/;
const DATE = /\d{4}-\d{2}-\d{2}/;

// Custom Type doc https://validatejs.org/#validators-type
// Custom validator doc https://validatejs.org/#custom-validator
// Custom async validator doc https://validatejs.org/#custom-validator-async

validate.extend(validate.validators.datetime, {
    // The value is guaranteed not to be null or undefined but otherwise it
    // could be anything.
    parse: function(value, { dateOnly } = {}) {
        if (dateOnly) {
            if (!DATE.test(value)) {
                return `wrong format: "${value}"`;
            }
        } else {
            if (!DATETIME.test(value)) {
                return `wrong format: "${value}"`;
            }
        }
        return new Date(value);
    },
    // Input is a unix timestamp
    format: function(value, options) {
        return new Date(value).toISOString();
    },
});

const buildTypeMultiple = itemType => value => {
    if (!Array.isArray(value)) {
        return false;
    }
    if (value.find(item => !itemType(item))) {
        return false;
    }
    return true;
};

validate.validators.type.types.uuid = value => isValidUuid(value);
validate.validators.type.messages.uuid = 'must be a valid UUID';

validate.validators.type.types.uuids = value => {
    return Array.isArray(value) && !value.find(v => !isValidUuid(v));
};
validate.validators.type.messages.uuids = 'must be a list of valid UUID';

validate.validators.type.types.object = value => typeof value === 'object';

validate.validators.type.types.hyperlink = value => {
    if (typeof value !== 'object') {
        return false;
    }
    const { link, text } = value;
    if (!link || typeof link !== 'string') {
        return false;
    }
    if (!text || typeof text !== 'string') {
        return false;
    }
    return text.trim().length > 0 && link.trim().length > 0;
};

validate.validators.type.messages.hyperlink = '{label} fields are required.';

validate.validators.type.types.entityReference = value => {
    if (typeof value !== 'object') {
        return false;
    }
    const { id, type, name, image } = value;
    if (!id || typeof id !== 'string' || !isValidUuid(id)) {
        return false;
    }
    if (!type || typeof type !== 'string' || type.length < 3) {
        return false;
    }
    if (!name || typeof name !== 'string' || name.length < 3) {
        return false;
    }
    if (image !== null && image !== undefined && typeof image !== 'string') {
        return false;
    }
    return true;
};

validate.validators.type.types.entityReferences = buildTypeMultiple(validate.validators.type.types.entityReference);

validate.validators.type.types.userReference = value => {
    if (typeof value !== 'object') {
        return false;
    }
    const { id, name, username, image } = value;
    if (!id || typeof id !== 'string' || !isValidUuid(id)) {
        return false;
    }
    if (!name || typeof name !== 'string' || name.length < 3) {
        return false;
    }
    if (!username || typeof username !== 'string' || username.length < 3) {
        return false;
    }
    if (image !== null && image !== undefined && typeof image !== 'string') {
        return false;
    }
    return true;
};

validate.validators.type.types.userReferences = buildTypeMultiple(validate.validators.type.types.userReference);

validate.validators.type.types.classReference = value => {
    if (typeof value !== 'object') {
        return false;
    }
    const { id, name, uri, color } = value;
    if (!id || typeof id !== 'string' || !isValidUuid(id)) {
        return false;
    }
    if (!name || typeof name !== 'string' || name.length < 3) {
        return false;
    }
    if (!uri || typeof uri !== 'string' || uri.length < 3 || !RFC_3986_URI_CUSTOMIZED.test(uri)) {
        return false;
    }
    if (color !== null && color !== undefined && typeof color !== 'string') {
        return false;
    }
    return true;
};

validate.validators.type.types.classReferences = buildTypeMultiple(validate.validators.type.types.classReference);

validate.validators.validValues = (value, validValues) => {
    if (value === undefined || (validValues || []).find(valid => value === valid)) {
        return;
    }
    return `"${value}" (${typeof value}) is not a valid value.`;
};

validate.validators.type.types.select = () => {
    // the validation is done by the validValues validator
    return true;
};

export default validate;
